define(function(require) {

    return {
        LAYER_ID : "GEO09E32_GDUNO_IMMBL",
        LAYER_TYPE : "POINT",
        LOADING_MODE : "ESRI",
        QUERY_EXPRESSION : "COORD_X_LL84 <> -1.111111",
        INDEX : 44,
        QUERY_FIELDS : ["CD_IMM", "NOM_OFFCL", "ADRS_GEO_L1_GDUNO", "CD_POSTL_GDUNO", "ORDRE_ENS", "STYLE_CARTOVISTA", "CD_CS"],
        FIELDS : [
            {ID : "CD_IMM", NAME : "Code immeuble", DATA_TYPE: "STRING"},
            {ID: "CD_CS", NAME: "Code de l'organisme responsable", DATA_TYPE: "STRING"},
            {ID : "NOM_OFFCL", NAME : "Nom", DATA_TYPE: "STRING"},
            {ID : "ADRS_GEO_L1_GDUNO", NAME : "Adresse", DATA_TYPE: "STRING"},
            {ID : "CD_POSTL_GDUNO", NAME : "Code postal", DATA_TYPE: "STRING"},
            {ID : "ORDRE_ENS", NAME : "Ordre d'enseignement", DATA_TYPE: "STRING"},
            {ID : "STYLE_CARTOVISTA", NAME: "Style cartovista", DATA_TYPE: "STRING"},
        ],
        STYLES: [
            {
                ID: "1_Imm_Anglo_primaire",
                NAME: "Anglophone - Primaire",
                VALUE: "1_Imm_Anglo_primaire",
                SYMBOLIZERS: [
                    {
                        SYMBOLIZER_TYPE: "ImagePointSymbolizer",
                        SRC: require("images/icones/public/immeubles/public_prim_anglo.png"),
                        SRC_ROLLOVER: require("images/icones/public/immeubles/public_prim_anglo_hover.png"),
                    }
                ],
                STYLE_LABEL_PROPERTIES: {
                    BOLD: true,
                    COLOR: "rgba(32,192,128,1)",
                    FONT_NAME: "Arimo-Regular",
                    FONT_FILE_SOURCE: "fonts/externals/Arimo-Regular",
                    HALO_COLOR: "rgba(255,255,255,1)",
                    HAS_HALO_COLOR: true,
                    SIZE: 9,
                    VISIBLE: true
                }
            }, {
                ID: "2_Imm_Anglo_prim_sec",
                NAME: "Anglophone - Primaire et secondaire",
                VALUE: "2_Imm_Anglo_prim_sec",
                SYMBOLIZERS: [
                    {
                        SYMBOLIZER_TYPE: "ImagePointSymbolizer",
                        SRC: require("images/icones/public/immeubles/public_prim_sec_anglo.png"),
                        SRC_ROLLOVER: require("images/icones/public/immeubles/public_prim_sec_anglo_hover.png")
                    }
                ],
                STYLE_LABEL_PROPERTIES: {
                    BOLD: true,
                    COLOR: "rgba(192,133,32,1)",
                    FONT_NAME: "Arimo-Regular",
                    FONT_FILE_SOURCE: "fonts/externals/Arimo-Regular",
                    HALO_COLOR: "rgba(255,255,255,1)",
                    HAS_HALO_COLOR: true,
                    SIZE: 9,
                    VISIBLE: true
                }
            }, {
                ID: "3_Imm_Anglo_secondaire",
                NAME: "Anglophone - Secondaire",
                VALUE: "3_Imm_Anglo_secondaire",
                SYMBOLIZERS: [
                    {
                        SYMBOLIZER_TYPE: "ImagePointSymbolizer",
                        SRC: require("images/icones/public/immeubles/public_sec_anglo.png"),
                        SRC_ROLLOVER: require("images/icones/public/immeubles/public_sec_anglo_hover.png")
                    }
                ],
                STYLE_LABEL_PROPERTIES: {
                    BOLD: true,
                    COLOR: "rgba(255,64,64,1)",
                    FONT_NAME: "Arimo-Regular",
                    FONT_FILE_SOURCE: "fonts/externals/Arimo-Regular",
                    HALO_COLOR: "rgba(255,255,255,1)",
                    HAS_HALO_COLOR: true,
                    SIZE: 9,
                    VISIBLE: true
                }
            }, {
                ID: "4_Imm_Anglo_Fp_Adulte",
                NAME: "Anglophone - Formation professionnelle et/ou adulte",
                VALUE: "4_Imm_Anglo_Fp_Adulte",
                SYMBOLIZERS: [
                    {
                        SYMBOLIZER_TYPE: "ImagePointSymbolizer",
                        SRC: require("images/icones/public/immeubles/public_form_prof_anglo.png"),
                        SRC_ROLLOVER: require("images/icones/public/immeubles/public_form_prof_anglo_hover.png")
                    }
                ],
                STYLE_LABEL_PROPERTIES: {
                    BOLD: true,
                    COLOR: "rgba(64,92,192,1)",
                    FONT_NAME: "Arimo-Regular",
                    FONT_FILE_SOURCE: "fonts/externals/Arimo-Regular",
                    HALO_COLOR: "rgba(255,255,255,1)",
                    HAS_HALO_COLOR: true,
                    SIZE: 9,
                    VISIBLE: true
                }
            }, {
                ID: "5_Imm_Anglo_Autre",
                NAME: "Anglophone - Autre",
                VALUE: "5_Imm_Anglo_Autre",
                SYMBOLIZERS: [
                    {
                        SYMBOLIZER_TYPE: "ImagePointSymbolizer",
                        SRC: require("images/icones/public/public_autre_anglo.png"),
                        SRC_ROLLOVER: require("images/icones/public/public_autre_anglo_hover.png")
                    }
                ],
                STYLE_LABEL_PROPERTIES: {
                    BOLD: true,
                    COLOR: "rgba(170,170,170,1)",
                    FONT_NAME: "Arimo-Regular",
                    FONT_FILE_SOURCE: "fonts/externals/Arimo-Regular",
                    HALO_COLOR: "rgba(255,255,255,1)",
                    HAS_HALO_COLOR: true,
                    SIZE: 9,
                    VISIBLE: true
                }
            }, {
                ID: "1_Imm_Franco_primaire",
                NAME: "Francophone - Primaire",
                VALUE: "1_Imm_Franco_primaire",
                SYMBOLIZERS: [
                    {
                        SYMBOLIZER_TYPE: "ImagePointSymbolizer",
                        SRC: require("images/icones/public/immeubles/public_prim_franco.png"),
                        SRC_ROLLOVER: require("images/icones/public/immeubles/public_prim_franco_hover.png")
                    }
                ],
                STYLE_LABEL_PROPERTIES: {
                    BOLD: true,
                    COLOR: "rgba(32,192,128,1)",
                    FONT_NAME: "Arimo-Regular",
                    FONT_FILE_SOURCE: "fonts/externals/Arimo-Regular",
                    HALO_COLOR: "rgba(255,255,255,1)",
                    HAS_HALO_COLOR: true,
                    SIZE: 9,
                    VISIBLE: true
                }
            }, {
                ID: "2_Imm_Franco_prim_sec",
                NAME: "Francophone - Primaire et secondaire",
                VALUE: "2_Imm_Franco_prim_sec",
                SYMBOLIZERS: [
                    {
                        SYMBOLIZER_TYPE: "ImagePointSymbolizer",
                        SRC: require("images/icones/public/immeubles/public_prim_sec_franco.png"),
                        SRC_ROLLOVER: require("images/icones/public/immeubles/public_prim_sec_franco_hover.png")
                    }
                ],
                STYLE_LABEL_PROPERTIES: {
                    BOLD: true,
                    COLOR: "rgba(192,133,32,1)",
                    FONT_NAME: "Arimo-Regular",
                    FONT_FILE_SOURCE: "fonts/externals/Arimo-Regular",
                    HALO_COLOR: "rgba(255,255,255,1)",
                    HAS_HALO_COLOR: true,
                    SIZE: 9,
                    VISIBLE: true
                }
            }, {
                ID: "3_Imm_Franco_secondaire",
                NAME: "Francophone - Secondaire",
                VALUE: "3_Imm_Franco_secondaire",
                SYMBOLIZERS: [
                    {
                        SYMBOLIZER_TYPE: "ImagePointSymbolizer",
                        SRC: require("images/icones/public/immeubles/public_sec_franco.png"),
                        SRC_ROLLOVER: require("images/icones/public/immeubles/public_sec_franco_hover.png")
                    }
                ],
                STYLE_LABEL_PROPERTIES: {
                    BOLD: true,
                    COLOR: "rgba(255,64,64,1)",
                    FONT_NAME: "Arimo-Regular",
                    FONT_FILE_SOURCE: "fonts/externals/Arimo-Regular",
                    HALO_COLOR: "rgba(255,255,255,1)",
                    HAS_HALO_COLOR: true,
                    SIZE: 9,
                    VISIBLE: true
                }
            }, {
                ID: "4_Imm_Franco_Fp_Adulte",
                NAME: "Francophone - Formation professionnelle et/ou adulte",
                VALUE: "4_Imm_Franco_Fp_Adulte",
                SYMBOLIZERS: [
                    {
                        SYMBOLIZER_TYPE: "ImagePointSymbolizer",
                        SRC: require("images/icones/public/immeubles/public_form_prof_franco.png"),
                        SRC_ROLLOVER: require("images/icones/public/immeubles/public_form_prof_franco_hover.png")
                    }
                ],
                STYLE_LABEL_PROPERTIES: {
                    BOLD: true,
                    COLOR: "rgba(64,92,192,1)",
                    FONT_NAME: "Arimo-Regular",
                    FONT_FILE_SOURCE: "fonts/externals/Arimo-Regular",
                    HALO_COLOR: "rgba(255,255,255,1)",
                    HAS_HALO_COLOR: true,
                    SIZE: 9,
                    VISIBLE: true
                }
            }, {
                ID: "5_Imm_Franco_Autre",
                NAME: "Francophone - Autre",
                VALUE: "5_Imm_Franco_Autre",
                SYMBOLIZERS: [
                    {
                        SYMBOLIZER_TYPE: "ImagePointSymbolizer",
                        SRC: require("images/icones/public/public_autre_franco.png"),
                        SRC_ROLLOVER: require("images/icones/public/public_autre_franco_hover.png")
                    }
                ],
                STYLE_LABEL_PROPERTIES: {
                    BOLD: true,
                    COLOR: "rgba(170,170,170,1)",
                    FONT_NAME: "Arimo-Regular",
                    FONT_FILE_SOURCE: "fonts/externals/Arimo-Regular",
                    HALO_COLOR: "rgba(255,255,255,1)",
                    HAS_HALO_COLOR: true,
                    SIZE: 9,
                    VISIBLE: true
                }
            }, {
                ID: "1_Imm_Statut_primaire",
                NAME: "Statut particulier - Primaire",
                VALUE: "1_Imm_Statut_primaire",
                SYMBOLIZERS: [
                    {
                        SYMBOLIZER_TYPE: "ImagePointSymbolizer",
                        SRC: require("images/icones/public/immeubles/public_prim_statut.png"),
                        SRC_ROLLOVER: require("images/icones/public/immeubles/public_prim_statut_hover.png")
                    }
                ],
                STYLE_LABEL_PROPERTIES: {
                    BOLD: true,
                    COLOR: "rgba(32,192,128,1)",
                    FONT_NAME: "Arimo-Regular",
                    FONT_FILE_SOURCE: "fonts/externals/Arimo-Regular",
                    HALO_COLOR: "rgba(255,255,255,1)",
                    HAS_HALO_COLOR: true,
                    SIZE: 9,
                    VISIBLE: true
                }
            }, {
                ID: "2_Imm_Statut_prim_sec",
                NAME: "Statut particulier - Primaire et secondaire",
                VALUE: "2_Imm_Statut_prim_sec",
                SYMBOLIZERS: [
                    {
                        SYMBOLIZER_TYPE: "ImagePointSymbolizer",
                        SRC: require("images/icones/public/immeubles/public_prim_sec_statut.png"),
                        SRC_ROLLOVER: require("images/icones/public/immeubles/public_prim_sec_statut_hover.png")
                    }
                ],
                STYLE_LABEL_PROPERTIES: {
                    BOLD: true,
                    COLOR: "rgba(192,133,32,1)",
                    FONT_NAME: "Arimo-Regular",
                    FONT_FILE_SOURCE: "fonts/externals/Arimo-Regular",
                    HALO_COLOR: "rgba(255,255,255,1)",
                    HAS_HALO_COLOR: true,
                    SIZE: 9,
                    VISIBLE: true
                }
            }, {
                ID: "3_Imm_Statut_secondaire",
                NAME: "Statut particulier - Secondaire",
                VALUE: "3_Imm_Statut_secondaire",
                SYMBOLIZERS: [
                    {
                        SYMBOLIZER_TYPE: "ImagePointSymbolizer",
                        SRC: require("images/icones/public/immeubles/public_sec_statut.png"),
                        SRC_ROLLOVER: require("images/icones/public/immeubles/public_sec_statut_hover.png")
                    }
                ],
                STYLE_LABEL_PROPERTIES: {
                    BOLD: true,
                    COLOR: "rgba(255,64,64,1)",
                    FONT_NAME: "Arimo-Regular",
                    FONT_FILE_SOURCE: "fonts/externals/Arimo-Regular",
                    HALO_COLOR: "rgba(255,255,255,1)",
                    HAS_HALO_COLOR: true,
                    SIZE: 9,
                    VISIBLE: true
                }
            }, {
                ID: "4_Imm_Statut_Fp_Adulte",
                NAME: "Statut particulier - Formation professionnelle et/ou adulte",
                VALUE: "4_Imm_Statut_Fp_Adulte",
                SYMBOLIZERS: [
                    {
                        SYMBOLIZER_TYPE: "ImagePointSymbolizer",
                        SRC: require("images/icones/public/immeubles/public_form_prof_statut.png"),
                        SRC_ROLLOVER: require("images/icones/public/immeubles/public_form_prof_statut_hover.png")
                    }
                ],
                STYLE_LABEL_PROPERTIES: {
                    BOLD: true,
                    COLOR: "rgba(64,92,192,1)",
                    FONT_NAME: "Arimo-Regular",
                    FONT_FILE_SOURCE: "fonts/externals/Arimo-Regular",
                    HALO_COLOR: "rgba(255,255,255,1)",
                    HAS_HALO_COLOR: true,
                    SIZE: 9,
                    VISIBLE: true
                }
            }, {
                ID: "5_Imm_Statut_Autre",
                NAME: "Statut particulier - Autre",
                VALUE: "5_Imm_Statut_Autre",
                SYMBOLIZERS: [
                    {
                        SYMBOLIZER_TYPE: "ImagePointSymbolizer",
                        SRC: require("images/icones/public/public_autre_statut.png"),
                        SRC_ROLLOVER: require("images/icones/public/public_autre_statut_hover.png")
                    }
                ],
                STYLE_LABEL_PROPERTIES: {
                    BOLD: true,
                    COLOR: "rgba(170,170,170,1)",
                    FONT_NAME: "Arimo-Regular",
                    FONT_FILE_SOURCE: "fonts/externals/Arimo-Regular",
                    HALO_COLOR: "rgba(255,255,255,1)",
                    HAS_HALO_COLOR: true,
                    SIZE: 9,
                    VISIBLE: true
                }
            }
        ],
        LAYER_PROPERTIES : {
            NAME : "Immeubles",
            FEATURE_ID_DATACOLUMN : "CD_IMM",
            FEATURE_NAME_DATACOLUMN : "NOM_OFFCL",
            DATATIP_DATACOLUMNS : ["NOM_OFFCL"],
            DATATIP_DATACOLUMNS_DISPLAY_MODE : "NONE",
            DATAVIEW_DATACOLUMNS : ["NOM_OFFCL", "CD_IMM", "ADRS_GEO_L1_GDUNO", "CD_POSTL_GDUNO", "ORDRE_ENS"],
            DATAVIEW_DATACOLUMNS_DISPLAY_MODE : "NONE",
            INFOVIEW_DATACOLUMNS : ["NOM_OFFCL", "CD_IMM", "ADRS_GEO_L1_GDUNO", "CD_POSTL_GDUNO", "ORDRE_ENS"],
            INFOVIEW_DATACOLUMN_DISPLAY_MODE : "NONE",
            SEARCHABLE_DATACOLUMNS : ["CD_IMM", "NOM_OFFCL"],
            SHOW_STYLES_IN_LAYER_CONTROL : false,
            STYLE_DATACOLUMN: "STYLE_CARTOVISTA",
            LABEL_DATACOLUMN : "NOM_OFFCL",
            LABEL_PROPERTIES : {
                ALLOW_LABEL_DUPLICATES : true,
                LEADER_LINES : false,
                POSITION : "MIDDLE-RIGHT",
                OFFSET_X : 2,
                PRIORITY : 5
            },
            VISIBLE : false,
            ZOOM_ON_FEATURE_SCALE : 6000
        }
    };
});
